import * as user from './user/actions'
import * as transcriptions from './transcriptions/actions'

export default { user, transcriptions }



// WEBPACK FOOTER //
// ./src/redux/actions.js